export default __webpack_public_path__ + "c04e989cdc33b8c42f9041f58b00b0c2.svg";